import { render } from "./FitnessNavigation.vue?vue&type=template&id=32d9dd0a&scoped=true"
import script from "./FitnessNavigation.vue?vue&type=script&lang=js"
export * from "./FitnessNavigation.vue?vue&type=script&lang=js"

import "./FitnessNavigation.vue?vue&type=style&index=0&id=32d9dd0a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32d9dd0a"]])

export default __exports__